/**
 * The one message the chrome layer sends *to* the frontend. The cold client cannot log an exposure
 * (logging off, no network), so it names the key and the frontend's live client logs it. Shared here
 * because both halves must agree on the string and neither imports the other.
 */
export const LOG_FEATURE_GATE_EXPOSURE_MESSAGE_TYPE = 'LOG_FEATURE_GATE_EXPOSURE';

export interface LogFeatureGateExposureMessage {
	readonly type: typeof LOG_FEATURE_GATE_EXPOSURE_MESSAGE_TYPE;
	/** A registered experiment key. Never a gate or a dynamic config; neither needs exposure. */
	readonly key: string;
}

export function isLogFeatureGateExposureMessage(
	data: unknown,
): data is LogFeatureGateExposureMessage {
	return (
		typeof data === 'object' &&
		data !== null &&
		(data as { type?: unknown }).type === LOG_FEATURE_GATE_EXPOSURE_MESSAGE_TYPE &&
		typeof (data as { key?: unknown }).key === 'string'
	);
}
